module.exports = __webpack_public_path__ + "img/galileo_icon3.d2614d36.png";